// extracted by mini-css-extract-plugin
module.exports = {"interactiveCard":"CorporatePrimaryActions_interactiveCard_2JTcX"};